<ul #navLinksList class="nav-links__list">
    <li *ngFor="let item of items" class="nav-links__item" [ngClass]="{
            'nav-links__item--has-submenu': item.menu,
            'nav-links__item--hover': hoveredItem === item.menu
        }" (click)="onClick(item, $event)" #itemElement>

        <ng-template #link>
            <div class="nav-links__item-body"
                [ngClass]="{'web-links__item--open':hoveredItem === item,'web-links__item--close':hoveredItem !== item}">
                <i class="{{ item.iconClass }}" aria-hidden="true"></i> &nbsp; {{ item.pageCaption }}
                <button *ngIf="item?.subMenu" class="web-links__item-toggle ml-2" type="button">
                    <app-icon class="web-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                </button>
            </div>
        </ng-template>
        <a *ngIf="!item.subMenu" class="nav-links__item-link myclass" [routerLink]="item.pageURL"
            (appTouchClick)="onTouchClick($event, item)" [ngClass]="{'colored':hoveredItem === item}">
            <ng-container [ngTemplateOutlet]="link"></ng-container>
        </a>
        <a *ngIf="item.subMenu" class="nav-links__item-link myclass" (appTouchClick)="onTouchClick($event, item)"
            [ngClass]="{'colored':hoveredItem === item}">
            <ng-container [ngTemplateOutlet]="link"></ng-container>
        </a>

        <div *ngIf="item.id != '19';else other_content" class="nav-links__submenu nav-links__submenu--type--menu"
            [ngClass]="{'nav-links__submenu--open': hoveredItem === item}" #submenuElement>
            <div *ngIf="hovered">
                <app-header-menu [id]="item.id" [items]="item.subMenu" (itemClick)="onSubItemClick()"></app-header-menu>
            </div>
        </div>
        <ng-template #other_content>
            <div class="nav-links__submenu nav-links__submenu--type--menu "
                [ngClass]="{'nav-links__submenu--open': hoveredItem === item}" #submenuElement>
                {{ item.id }}
                <app-header-megamenu [items]="item.subMenu" [menu]="item.subMenu"
                    (itemClick)="onSubItemClick()"></app-header-megamenu>
            </div>
        </ng-template>
    </li>
</ul>
